import * as React from 'react';
import { MessageBar, MessageBarType } from 'office-ui-fabric-react/lib/MessageBar';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export const FieldErrorMessage = _ref => {
  let {
    children = null,
    isMultiline = false,
    styles
  } = _ref;
  if (!children) return /*#__PURE__*/_jsx(_Fragment, {});
  return /*#__PURE__*/_jsx(TooltipHost, {
    tooltipProps: !isMultiline ? {
      onRenderContent: () => /*#__PURE__*/_jsx(_Fragment, {
        children: children
      })
    } : {},
    children: /*#__PURE__*/_jsx(MessageBar, {
      styles: styles,
      messageBarType: MessageBarType.error,
      isMultiline: isMultiline,
      dismissButtonAriaLabel: "Close",
      "data-id": "field-error",
      children: children
    })
  });
};